import Lang from "../../../userPreferences/staticWords";

const AdminTable = ({ setRowInfo, rowInfo, data, currentPage = 1 }) => {
  let globalIndex = [];
  return (
    <div
      className="px-2 table-scroll mb-3"
      style={{
        overflowX: "auto",
        overflowY: "auto",
        // height: 270,
        width: "100%",
      }}
    >
      <table className="table mb-1" style={{ border: "solid 1px #dee2e6" }}>
        <thead>
          <tr
            className="table-row sticky-top bg-white"
            id="hi"
            style={{ zIndex: 900 }}
          >
            <th scope="col">#</th>
            {Object.keys(data?.length ? data[0] : {}).map((item, index) => {
              if (item == "id" || item == "logo") globalIndex.push(index);
              else
                return (
                  <th key={index} scope="col">
                    {Lang[item] ?? item}
                  </th>
                );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            return (
              <tr
                key={index}
                style={{ height: 55 }}
                id={item.id}
                className="table-row"
                onClick={(e) => {
                  whichActive(e.currentTarget);
                  e.currentTarget.id == null
                    ? setRowInfo({
                        show: true,
                        id: e.currentTarget.id,
                        userData: item,
                      })
                    : e.currentTarget.id == rowInfo.id
                    ? setRowInfo({ show: false, id: null, userData: {} })
                    : setRowInfo({
                        show: true,
                        id: e.currentTarget.id,
                        userData: item,
                      });
                }}
              >
                <th scope="row">{index + 1 + (currentPage - 1) * 10}</th>
                {Object.values(item).map((slice, index) => {
                  if (!globalIndex.includes(index))
                    return (
                      <td key={index}>
                        {slice === true || slice === false
                          ? Lang[slice]
                          : slice ?? " "}
                      </td>
                    );
                })}
                {/* <td>{item.firstName ?? "لا يوجد"}</td>
                <td>{item.lastName ? item.lastName : "لا يوجد"}</td>
                <td>{item.mobileNumber ?? "لا يوجد"}</td>
                <td>{item.email ?? "لا يوجد"}</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTable;
function whichActive(element) {
  let id = element.id;
  let className = "table-row";

  //  selectedtr
  let list = document.getElementsByClassName(className);
  for (let i = 0; i < list.length; i++) {
    const element = list.item(i);
    if (element?.classList?.contains(className)) {
      if (element.id != id) element?.classList?.remove("selectedtr");
    }
  }
  document.getElementById(id)?.classList?.toggle("selectedtr");
}
